// extracted by mini-css-extract-plugin
export default {"container":"Policy_container__CmvL1","title":"Policy_title__R4GSn"};